import { useState } from 'react';

export default function Services() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const services = [
    {
      title: '施工体制台帳作成代行',
      badge: '',
      items: [
        '下請負人一覧',
        '作業員名簿',
        '再下請通知',
        '現場マスター登録',
        '法定添付書類のチェック'
      ],
      image: 'https://public.readdy.ai/ai/img_res/912d781a5b88bc74fa00fe557be0322a.jpg'
    },
    {
      title: '安全衛生書類の作成代行',
      badge: '人気No.1',
      items: [
        '安全衛生管理体制図',
        '巡視表',
        '資格証、雇用・保険関係の確認',
        '建設業労務安全書類一式',
        'グリーンサイト登録・更新'
      ],
      image: 'https://readdy.ai/api/search-image?query=construction%20safety%20and%20health%20documents%20with%20worker%20safety%20management%20charts%20and%20inspection%20checklists%2C%20organized%20professional%20forms%20with%20clear%20sections%20and%20official%20layout&width=800&height=1000&seq=service-002&orientation=portrait'
    },
    {
      title: '書類の電子化サポート',
      badge: '電子化対応',
      items: [
        'グリーンサイト',
        'ワークサイト',
        'サイトアシスト 等',
        'PDF変換・アップロード代行'
      ],
      image: 'https://readdy.ai/api/search-image?query=tablet%20device%20displaying%20green%20site%20digital%20platform%20interface%20with%20construction%20document%20management%20system%2C%20modern%20clean%20UI%20showing%20worker%20registration%20and%20file%20upload%20sections&width=800&height=1000&seq=service-003&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1a2332]">
            サービス内容
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 mt-3">
            WEBサイト入力に伴う対応のみ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`relative rounded-2xl overflow-hidden shadow-xl transition-all duration-500 cursor-pointer h-[500px] sm:h-[600px] ${
                hoveredCard === index ? 'md:scale-105' : ''
              }`}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
              
              {service.badge && (
                <div className="absolute top-4 sm:top-6 left-4 sm:left-6">
                  <div className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white rounded-full text-[#1a2332] text-xs sm:text-sm font-bold flex items-center gap-2 whitespace-nowrap shadow-lg">
                    <i className="ri-star-fill text-[#ff6b35]"></i>
                    {service.badge}
                  </div>
                </div>
              )}

              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">
                  {service.title}
                </h3>
                <ul className="space-y-2 sm:space-y-3">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="text-sm sm:text-base text-white flex items-start gap-2 sm:gap-3 leading-relaxed">
                      <i className="ri-check-line text-[#ff6b35] text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
